export default {
  cdob: "",
  cage: "",
  name: "",
  AnnualIncome: "",
  age: 0,
  dob: "",
  gender: "Male",
  MobileNo: "",
  EmailId: "",
  trai: true,
  paymentOption: "regular_pay",
  saMultiple: "",
  whole_life: false,
  relation: "Self",
  premium: 10000,
  mode: "yearly",
  ppt: 20,
  term: 20,
  lifeCover: 2400000,
  payout: "LumpSum",
  staff: "No",
  adbr: 0,
  productId: "UA8",
  invest_type: "yourChoice",
  invest_strat: "aggressive",
  OutputObjHold_4: 0,
  OutputObjHold_8: 0,
  funds: {
    multi_cap_growth: 0,
    bluechip: 0,
    opportunities: 0,
    maximiser_v: 1,
    multi_cap_balanced: 0,
    income: 0,
    money_market: 0,
    mid_cap: 0,
    maximise_india: 0,
    active_asset_allocation_balanced: 0,
    value_enhancer: 0,
    secure_opportunities: 0,
    focus_50: 0,
    india_growth: 0,
    balanced_advantage: 0,
    sustainable_equity: 0,
    mid_cap_hybrid: 0,
  },
  swp: {
    SWP: "No",
    SWP_mode: "monthly",
    SWP_payDate: "5",
    year: [0, 0, 0, 0, 0],
    payout_per: [0, 0, 0, 0, 0],
    retStart_Yr: "",
    ret_payout_per: "4",
  },
  ats: {
    ats: "No",
    fundFrm: "",
    fundTo: "bluechip",
    date: "1",
    amount: "",
  },
  fundCat: {
    Equity: 100,
    Balanced: 0,
    Debt: 0,
  },
  calcType: {
    key: "Wealth",
  },
  selectedFunds: [],
};
